<template>
  <base-modal ref="modal">
    <base-card shadow>
      <div class="tw-text-lg">{{ businessPlan.name }}</div>
      <div class="tw-text-gray-600 tw-mt-2">{{ businessPlan.descriptionLong }}</div>
      <div class="tw-mt-6">
        <!-- Price -->
        <div class="tw-flex tw-justify-between">
          <div class="tw-text-gray-800">Price</div>
          <div class="tw-text-gray-800 tw-font-normal tw-text-sm">
            <Money-Format
              class="tw-text-gray-800 tw-text-right"
              :value="businessPlan.priceCents"
              :locale="locale"
              :currency-code="businessPlan.priceCurrency"
              :subunits-value="true"
              :hide-subunits="false"
            ></Money-Format>
          </div>
        </div>
        <!-- Down Payment -->
        <div class="tw-flex tw-justify-between tw-mt-3">
          <div class="tw-flex tw-flex-col">
            <div class="tw-text-gray-800">Initial Down Payment</div>
            <div class="tw-text-gray-600 tw-text-xs">Added to initial activation charge</div>
          </div>

          <div class="tw-text-gray-800 tw-font-normal tw-text-sm tw-my-auto">
            <Money-Format
              class="tw-text-gray-800 tw-text-right"
              :value="businessPlan.downPaymentCents"
              :locale="locale"
              :currency-code="businessPlan.priceCurrency"
              :subunits-value="true"
              :hide-subunits="false"
            ></Money-Format>
          </div>
        </div>
        <!-- Cycle -->
        <div class="tw-flex tw-justify-between tw-mt-3">
          <div class="tw-text-gray-800">Billing Cycle</div>
          <div class="tw-text-gray-800 tw-font-normal tw-text-sm">
            {{ cycleText }}
          </div>
        </div>
        <!-- Term Length -->
        <div class="tw-flex tw-justify-between tw-mt-3">
          <div class="tw-text-gray-800">Term Length</div>
          <div class="tw-text-gray-800 tw-font-normal tw-text-sm">
            {{ term }}
          </div>
        </div>
        <!-- Auto-Renew -->
        <div class="tw-flex tw-justify-between tw-mt-3">
          <div class="tw-text-gray-800">End of Term</div>
          <div class="tw-text-gray-800 tw-font-normal tw-text-sm">
            {{ businessPlan.isAutoRenew ? "Plan auto-renews" : "Plan will cancel" }}
          </div>
        </div>
      </div>
      <div class="tw-flex tw-justify-end tw-mt-6">
        <base-button type="secondary" color="gray" @click="hide">
          Close
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import MoneyFormat from "vue-money-format";

export default {
  name: "Details",
  components: {
    MoneyFormat,
  },
  props: {
    businessPlan: Object,
  },
  computed: {
    locale() {
      return window.navigator.language;
    },
    cycleText() {
      var cycleFrequencyText = "every " + this.businessPlan.cycleFrequency;
      var cycleIntervalText = this.businessPlan.cycleInterval;

      return this.businessPlan.cycleFrequency === 1 ? cycleFrequencyText + " " + cycleIntervalText : cycleFrequencyText + " " + cycleIntervalText + "s";
    },
    term() {
      if (this.businessPlan.isAutoRenew === false) {
        if (this.businessPlan.cycleEndCount != null) {
          return this.businessPlan.cycleEndCount + " payments";
        } else {
          return this.businessPlan.cycleEndInterval == "year"
            ? this.businessPlan.cycleEndIntervalCount * 12 + " months"
            : this.businessPlan.cycleEndIntervalCount > 1
            ? this.businessPlan.cycleEndIntervalCount + " " + this.businessPlan.cycleEndInterval + "s"
            : this.businessPlan.cycleEndIntervalCount + " " + this.businessPlan.cycleEndInterval;
        }
      } else {
        return this.businessPlan.termInterval == "year"
          ? this.businessPlan.termLength * 12 + " months"
          : this.businessPlan.termLength > 1
          ? this.businessPlan.termLength + " " + this.businessPlan.termInterval + "s"
          : this.businessPlan.termLength + " " + this.businessPlan.termInterval;
      }
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
};
</script>
